import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmActionModalComponent } from '@app/trackvision/shared/components/confirm-action-modal/confirm-action-modal.component';
import { TypeEntity } from '@app/trackvision/shared/enums/type-entity-enum';
import { ModalFormCostComponent } from '@app/trackvision/shared/pop-up/modal-form-cost/modal-form-cost.component';
import { ModalFormFeeComponent } from '@app/trackvision/shared/pop-up/modal-form-fee/modal-form-fee.component';
import { Pagination } from '@models/pagination';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CostService } from '@services/cost.service';

@Component({
    selector: 'app-cost-requirement',
    templateUrl: './cost-requirement.component.html',
    styleUrls: ['./cost-requirement.component.scss'],
    standalone: false
})
export class CostRequirementComponent implements OnInit {

  @Input() costs: Object[];
  @Input() requirementId: any;
  @Output() loadCosts = new EventEmitter<boolean>();

  pagination: Pagination;
  skip: string;
  take: string;
  typeEntity = TypeEntity;

  listTypeCosts = [
    { id: "provision", name: "Movilización" },
    { id: "notary", name: "Notaría" },
    { id: "collation", name: "Colación" },
    { id: "notification", name: "Notificación" },
    { id: "expertise", name: "Peritaje" },
    { id: "publication", name: "Publicación" },
    { id: "taxes", name: "Impuestos" },
    { id: "others", name: "Otros" }
  ]

  listTypeFee = [
    { id: "forhh", name: "Por hh" },
    { id: "only", name: "Único" },
    { id: "monthlyfee", name: "Fee Mensual" },
    { id: "propotional", name: "Proporcional" },
    { id: "monthly", name: "Mensual" },
  ]

  constructor(
    private elementRef: ElementRef,
    private modalService: NgbModal,
    private costService: CostService,
  ) {

  }

  ngOnInit() {

    this.initPaginator();

  }

  ngAfterViewInit() {

    const elements = document.querySelectorAll('.fa-ellipsis-v');

    elements.forEach((element) => {
      element.classList.remove('dropdown-toggle');
    });

  }

  initPaginator() {
    this.pagination = new Pagination();
    this.pagination.current_page = 1;
    this.pagination.per_page = 10;
    this.pagination.total = this.costs.length;
    this.skip = ((this.pagination.current_page - 1) * this.pagination.per_page).toString();
    this.take = ((this.pagination.current_page - 1) * this.pagination.per_page + this.pagination.per_page).toString();

  }

  pageChanged(page: number): void {
    this.pagination.current_page = page;
    this.loadCosts.emit(true);
  }

  refreshTable() {
    this.skip = ((this.pagination.current_page - 1) * this.pagination.per_page).toString();
    this.take = ((this.pagination.current_page - 1) * this.pagination.per_page + this.pagination.per_page).toString();
    this.loadCosts.emit(true);

  }


  openModalToEdit(row){
    if(row.typeEntity == TypeEntity.costs){
      this.openModalToEditCost(row);
    }else{
      this.openModalToEditFee(row);
    }
  }


  //#region Abrir Modal para Crear Costo
  openModalToEditCost(row: any) {

    let idCost = row.id
    let titleModal: string = "";
    let isEdit: boolean = false;

    if (idCost == null || idCost == undefined) {
      isEdit = false;
      titleModal = 'Crear Gasto'
    }
    else {
      isEdit = true;
      titleModal = 'Editar Gasto';
    }

    const modalRef = this.modalService.open(ModalFormCostComponent, {
      scrollable: true, size: 'md', backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.requirementId = this.requirementId;
    modalRef.componentInstance.IdCost = idCost;
    modalRef.componentInstance.titleModal = titleModal;
    modalRef.componentInstance.isEdit = isEdit;
    modalRef.componentInstance.costArray = row;
    modalRef.componentInstance.insertCost.subscribe(insertCost => {
      if (insertCost) {
        this.loadCosts.emit(true);
      }
    });

  }
  //#endregion

  openModalToEditFee(row: any) {

    let idCost = row.id
    let titleModal: string = "";
    let isEdit: boolean = false;

    if (idCost == null || idCost == undefined) {
      isEdit = false;
      titleModal = 'Crear Honorario'
    }
    else {
      isEdit = true;
      titleModal = 'Editar Honorario';
    }

    const modalRef = this.modalService.open(ModalFormFeeComponent, {
      scrollable: true, size: 'md', backdrop: 'static',
      keyboard: false
    });

    modalRef.componentInstance.requirementId = this.requirementId;
    modalRef.componentInstance.IdFee = idCost;
    modalRef.componentInstance.titleModal = titleModal;
    modalRef.componentInstance.isEdit = isEdit;
    modalRef.componentInstance.costArray = row;
    modalRef.componentInstance.insertCost.subscribe(insertCost => {
      if (insertCost) {
        this.loadCosts.emit(true);
      }
    });

  }


  //#region Abrir Modal para eliminar Costo
  openModalToDeleteCost(IdCost: number) {

    const confirmModal = this.modalService.open(ConfirmActionModalComponent, { size: 'sm', centered: true });
    confirmModal.componentInstance.message = `¿Deseas eliminar el costo del requerimiento?`;
    confirmModal.result.then((confirmed) => {
      if (confirmed) {
        this.deleteCost(IdCost);
      }
    }).catch();

    return;
  }
  //#endregion


  //#region Funcionalidad eliminar Costo
  deleteCost(IdCost: number) {
    let object = { id: IdCost }

    this.costService.deleteCost(object).subscribe(
      data => {
        setTimeout(() => this.loadCosts.emit(true), 1000);
      },
      error => {
        console.error('Error al eliminar costo.');
        console.error(error);
      }
    );
  }
  //#endregion

  getLabelById(id, arrayTypes:Array<any>):string{
    const obj:any = arrayTypes.find((item:any)=> item.id == id);
    if(obj){
      return obj.name;
    }else{
      return 'NA';
    }

  }

}
